import React, { useState, useEffect, useContext, useRef } from 'react';

import loadBodyContent from './ProductModalContentWrapper.jsx';
import { Modal } from 'web-store-modules/packages/web-store-ui-library';
import { ProductModalContext } from '../../ProductModalContext.jsx';

import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import { ComponentTypes, ContentTypes } from '../util/ProductModalEnums.js';

const { reactRoot } = require('../../../../../../../../variables/Variables.js');

import './ProductModal.css';
import ProductModalCartOverlay from './ProductModalCartOverlay.jsx';
import { ProductHotspotClicked } from '../../../../../../utils/Analytics.js';

const isMobile = isMobileDevice();
const geSymbol = `https://cdn.obsess-vr.com/vacheron/ge-symbol.png`
const productCloseIcon = `https://cdn.obsess-vr.com/vacheron/vac_xicon_white.svg`
// Arrays that determine the load order of modal content
const headerLoadOrder = [ComponentTypes.TITLE, ComponentTypes.DESCRIPTION, ComponentTypes.DETAILS_BODY_1];
const bodyLoadOrder = [ComponentTypes.PRICE, ComponentTypes.SALE_PRICE, ComponentTypes.COLOR_SELECTOR, ComponentTypes.PRODUCT_IMAGE, ComponentTypes.PRODUCT_BUTTONS];

const preventDefault = (e) => e.preventDefault();


const ProductModal = ({ onClose, isMall, renderProductContent, footer }) => {

    const { setModalOpened, isLoading, primaryColor, detailsActive, showingAddToCartPrompt, focusMode, contentHeight, setContentHeight, productInfo } = useContext(ProductModalContext);
    const [hidePinchTip, setHidePinchTip] = useState(!!sessionStorage.getItem('hidePinchTip'));

    const contentContainer = useRef();
    const animationType = isMall ? 'blur' : 'flyup'

    // TODO: Populate styles from product modal context, possibly taken from CMS settings
    const closeIconStyle = { float: 'right', visibility: focusMode ? 'hidden' : 'visible', margin: '15px', width: '15px' };
    const closeContainerStyle = {
        width: '2.8em',
        height: '2.8em',
        position: 'absolute',
        top: '-1em',
        right: '-1em',
        zIndex: 210,
        borderRadius: '50%',
        backgroundColor: '#C3A07D',
    };
    const productModalContainerStyle = {
        height: focusMode ? '100vh' : isMobile ? `${document.getElementById(reactRoot).offsetHeight * .77}px` : `${document.getElementById(reactRoot).offsetHeight * .75}px`,
        width: focusMode ? '100vw' : isMobile ? '80vw' : '21em',
        padding: focusMode ? '0' : '1em 1em 0',
        fontWeight: '400',
        fontFamily: 'Prelo-Light'
        // backgroundColor
    };

    useEffect(() => {
        ProductHotspotClicked(productInfo[ContentTypes.TITLE]);
        setContentHeight(contentContainer.current.clientHeight - 60);

        // We use native DOM manipulation here because the react onTouchMove event listener isn't preventing defaults
        if (!hidePinchTip) {
            setTimeout(() => {
                setHidePinchTip(true);
                // If a user doesn't pinch to zoom within two seconds. hide pinch tooltip for the rest of the session, 
                // this is to prevent spamming the user with this tooltip
                if (!sessionStorage.getItem('hidePinchTip')) {
                    sessionStorage.setItem('hidePinchTip', true);
                }
            }, 2000);
            document.addEventListener('touchmove', hideOnPinch, { passive: false });

            // Event Listener is targeting a specific option in addEventListener to disable
            // Mousewheel affects zoom in Safari (Desktop)
            // All event listeners use a shared preventDefault function so that the removeEventListener calls have a specific function to remove
            document.addEventListener('mousewheel', preventDefault, { passive: false });
            // False sets useCapture to false, handler will only be called during bubbling phase
            // Prevents zoom in iOS Safari when Modal is open
            document.addEventListener('touchmove', preventDefault, false);
            // Disables pinch to zoom on Safari w/ macOS trackpad
            document.addEventListener('gesturestart', preventDefault);
            document.addEventListener('gesturechange', preventDefault);
            document.addEventListener('gestureend', preventDefault);

            return function cleanUp() {
                document.removeEventListener('touchmove', hideOnPinch, { passive: false });
                document.removeEventListener('mousewheel', preventDefault, { passive: false });
                document.removeEventListener('touchmove', preventDefault, false);
                document.removeEventListener('gesturestart', preventDefault);
                document.removeEventListener('gesturechange', preventDefault);
                document.removeEventListener('gestureend', preventDefault)
            };
        }
    }, []);

    const hideOnPinch = (e) => {
        if (hidePinchTip && e.touches.length === 2) {
            sessionStorage.setItem('hidePinchTip', true);
            setHidePinchTip(true);
            e.preventDefault();
        } else if (e.touches.length > 1) {
            e.preventDefault();
        }
    }

    return (
        <Modal animationType={animationType} setModalOpened={setModalOpened} onClose={onClose} reactRootId={reactRoot} closeIconStyle={closeIconStyle} closeContainerStyle={closeContainerStyle} isLoading={isLoading} wrapperStyle={{ backgroundColor: focusMode ? 'rgba(0, 0, 0, 1)' : 'rgb(255, 255, 255)' }} closeIconNormal={productCloseIcon}>
            <div id="product-modal-container" className='flex' style={productModalContainerStyle}>
               <div id="product-modal-header" className="flex" style={{ display: focusMode ? 'none' : 'flex', opacity: detailsActive ? '0' : '1' }}>
                    <span>
                        <img src={geSymbol} width="25" className="ge-symbol" alt="ge-symbol" />
                    </span>
                    {renderProductContent(headerLoadOrder)}
                </div>
                <div id="product-modal-content" ref={contentContainer} className="flex flex-1" style={{ transform: detailsActive ? 'translateY(-100%)' : 'translateY(0)' }}>
                    <div id='product-modal-transition-wrapper' className='flex flex-1' style={{ minHeight: `${contentHeight}px`, opacity: detailsActive ? '0' : '1' }}>
                        {renderProductContent(bodyLoadOrder)}
                    </div>
                    <div className='product-modal-details-container' style={{ minHeight: `${contentHeight}px`, opacity: detailsActive ? '1' : '0' }}>
                        <p class="product-description" >
                            {renderProductContent([ComponentTypes.PRODUCT_DETAILS])}
                        </p>
                        <p class="product-price">
                            {renderProductContent([ComponentTypes.PRICE])}
                        </p>
                    </div>
                </div>
                <div id="product-modal-footer" className='align-bottom flex-center flex-no-shrink' style={{ display: focusMode ? 'none' : 'flex' }}>
                    {footer}
                </div>
            </div>
        </Modal >
    );
}

export default loadBodyContent(ProductModal);